const scripts = new Map<string, Promise<void>>()

// Сторонние скрипты подключаем из кода, а не тегом в <head>: тег там
// останавливает разбор страницы, и кабинет не стартует, пока чужой домен
// не ответит. Промис резолвится и при неудаче — вызывающий код проверяет,
// появился ли нужный глобальный объект
export const loadScript = (src: string, timeoutMs: number): Promise<void> => {
  const started = scripts.get(src)
  if (started) return started

  const loading = new Promise<void>((resolve) => {
    const script = document.createElement('script')
    const timer = window.setTimeout(resolve, timeoutMs)
    const finish = () => {
      window.clearTimeout(timer)
      resolve()
    }

    script.src = src
    script.async = true
    script.onload = finish
    // после отказа даём загрузить заново: тег с ошибкой ничего не выполнил
    script.onerror = () => {
      scripts.delete(src)
      finish()
    }
    document.head.appendChild(script)
  })

  scripts.set(src, loading)

  return loading
}
